<template>
	<div id="panel-4" class="panel">
		<div class="panel-hdr ">
			<h2>
				{{__t('LIST')}} <span class="fw-300"><i>{{__t('PRODUCTS')}}</i></span>
			</h2>

			<div class="panel-toolbar">
                <button class="btn btn-icon btn-sm btn-success mr-1 shadow-0 waves-effect waves-themed" v-on:click="create">
                    <i class="fal fa-plus"></i>
                </button>

                <button class="btn btn-icon btn-sm btn-warning mr-1 shadow-0 waves-effect waves-themed" v-on:click="create_combo">
                    <i class="fal fa-plus"></i>
                </button>

                <button class="btn btn-icon  btn-sm btn-outline-info  shadow-0  waves-effect waves-themed mr-2"  v-on:click="remove_skip_sync">
                    <i class="fal fa-money-check-edit-alt"></i>
                </button>

                <button class="btn btn-icon  btn-sm btn-outline-info  shadow-0  waves-effect waves-themed mr-2 ml-2" style="min-width: 200px"  v-on:click="sync_menu">
                    {{__t('IMPORT_MARKET_MENU')}}
                </button>

				<button class="btn btn-panel waves-effect waves-themed"
						data-action="panel-fullscreen"
						data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen">
				</button>
			</div>
		</div>
		<div class="panel-container show">
			<div class="panel-content">
				<div class="filter_block mb-3">
					<filter_catalog></filter_catalog>
				</div>
				<b-skeleton-table v-if="is_load" :rows=this.cur_records :columns="2"
                  :hide-header=true
                  :table-props="{ bordered: false, striped: true }"
				>
				</b-skeleton-table>

				<div class="inbox_vue_list" v-if="!is_load">
					<div class="org_filter">

					</div>

					<div class="inb_pagi pt-4" v-if="rows.length > 0">
						<sys_pagination key="up"></sys_pagination>
					</div>


					<b-table
						v-if="rows.length > 0"
						:thead-class="head_class"
						:tbody-tr-class="rowClass"
						 class="table-responsive-xl resolution_table product_list" :items="rows" :fields="fields">

						<template v-slot:table-busy>
							<div class="text-center text-danger my-2">
								<b-spinner class="align-middle"></b-spinner>
								<strong>Working...</strong>
							</div>
						</template>

						<!-- header fields -->
						<template v-slot:head(id)="data">
							<div class="custom-control custom-checkbox">
								<input
									:disabled="true"
									v-model="is_check_all"
									type="checkbox"
									v-on:click="check_all"
									class="custom-control-input"
									id="imc_checker_all" />
								<label class="custom-control-label cursor-pointer bolder" for="imc_checker_all"></label>
							</div>
						</template>

						<template  v-slot:head(filename)="data">
							<div class="fs-xl text-left" v-html="data.label"></div>
						</template>

						<template v-slot:head(ordering)="data">
							<grid  list_ordering="ordering"  :is_html=true :field_name="data.label" ></grid>
						</template>


						<template v-slot:head(title)="data">
							<grid  list_ordering="title" :field_name="__t('TITLE') " ></grid>
						</template>

						<template v-slot:head(price)="data">
							<grid  list_ordering="price" :field_name="__t('PRICE')" ></grid>
						</template>

						<template  v-slot:head(uniq_id)="data">
							<div class="fs-xl text-center" v-html="data.label"></div>
						</template>

						<!-- body draw -->
						<template  v-slot:cell(id)="data" class="small_td">
							<div class="custom-control custom-checkbox">
								<input
									v-on:click="save_product_publish(data.item)"
									v-model="data.item.published"
									:name="'cid[]'"
									type="checkbox"
									class="custom-control-input"
									:id="data.item.id + '_cust_id'" />

								<label class="custom-control-label cursor-pointer bolder" :for="data.item.id + '_cust_id'"></label>
							</div>
						</template>

						<template v-slot:cell(ordering)="data">
                            <b-dropdown size="sm"  variant="link" toggle-class="text-decoration-none" no-caret>
                                <template #button-content>
                                    <div class="btn btn-primary btn-icon rounded-circle position-relative js-waves-off">
                                        <i class="fal fa-sort"></i>
                                        <span class="badge border border-light rounded-pill bg-danger-500 position-absolute pos-top pos-right">
                                            {{data.item.ordering}}
                                        </span>
                                    </div>
                                </template>

                                    <b-dropdown-form class="p-3">
                                        <b-form-group :label="__t('ORDERING')" label-for="dropdown-form-email" @submit.stop.prevent>
                                            <b-form-input
                                                id="dropdown-form-email"
                                                size="sm"
                                                type="number"
                                                v-model="data.item.ordering"
                                                :placeholder="__t('CHANGE_ORDERING')"
                                            ></b-form-input>

                                            <b-button class="mt-2" variant="primary" size="sm" @click="change_ordering(data.item)">
                                                {{__t('SAVE')}}
                                            </b-button>

                                        </b-form-group>
                                    </b-dropdown-form>

                            </b-dropdown>
						</template>

						<template v-slot:cell(filename)="data">
							<div class="img_block  rounded">
								<picture>
									<source :srcset="data.item.main_photo.webp" type="image/webp">
									<source :srcset="data.item.main_photo.jpeg" type="image/jpeg">
									<img itemprop="image" :src="data.item.main_photo.jpeg">
								</picture>
							</div>
						</template>

						<template v-slot:cell(title)="data">
							<div class="prod_name  fs-xl ">

                                <div class="d-flex flex-start w-100 fs-xl mb-2" >
                                    <div  class="icon-stack fs-xxl mr-2 cursor-pointer cursor-pointer hidden-md-down" v-on:click="load_preview_details(data)">
                                        <i class="base base-15 icon-stack-3x opacity-100 color-primary-900"></i>
                                        <i class="fal fa-indent icon-stack-1x opacity-100 color-white"></i>
                                    </div>

                                    <span v-html=nice_search(data.item.title)></span>
                                    <span class="small text-info pl-2">
									    <i class="fal fa-lock" v-if="data.item.skeep_sync"></i>
								    </span>
                                </div>


							</div>
							<div class="categ_name">
								<div class="small badge border border-primary text-primary" v-if="data.item.main_categ">
									{{data.item.main_categ.title}}
								</div>

                                <div class="small badge badge-dark " v-if="data.item.go_type">
                                    {{data.item.go_type}}
                                </div>
							</div>

                            <!--
							<div class="mt-1">
                                <div class="small badge border border-warning text-black-50  mr-1">
                                    {{data.item.prov_name}}
                                </div>
							</div>
							-->

							<div class="art" v-if="data.item.product_code">
								Code : <span v-html=nice_search(data.item.product_code)></span>
							</div>

						</template>

						<template v-slot:cell(price)="data">

							<div class="prod_price bold color-primary-900 mt-1 position-relative">
								{{new Intl.NumberFormat('ru-RU').format(parseFloat(data.item.price))}}
								<span class="woocommerce-Price-currencySymbol  fs-sm"></span>

                                <span

                                    v-if="data.item.hasOwnProperty('rest_price_count') && parseInt(data.item.rest_price_count) > 0"
                                    class="rounded-circle  js-waves-off small fs-xs">
                                    <span class="badge border border-light
                                    rounded-pill bg-danger-500
                                    position-absolute
                                    pos-top pos-right"    style="top:-5px" >
                                        {{parseInt(data.item.rest_price_count)}}
                                    </span>
                                    </span>
							</div>

                            <div class="prod_price fs-xs  color-info-900 mt-1" v-if="data.item.price_weight > 0">
                                {{new Intl.NumberFormat('ru-RU').format(parseFloat(data.item.price_weight))}}
                                <span class="woocommerce-Price-currencySymbol  fs-sm"></span>
                            </div>


                            <div class="prod_price fs-xs  color-info-900 mt-1" v-if="data.item.hidden_modifiers_price > 0">
                               + {{new Intl.NumberFormat('ru-RU').format(parseFloat(data.item.hidden_modifiers_price))}}
                                <span class="woocommerce-Price-currencySymbol  fs-sm"></span>
                            </div>

							<div class="prod_price fs-xs  color-success-900 mt-1" v-if="percent_info.percent > 0">
								{{new Intl.NumberFormat('ru-RU').format(parseFloat(data.item.final_price))}}
								<span class="woocommerce-Price-currencySymbol  fs-sm"></span>
							</div>


						</template>

						<template  v-slot:cell(uniq_id)="data">
							<div class="text-center mt-4">
								<i class="text-center fal fa-cog width-2 cursor-pointer fs-xxl color-primary-900" v-on:click.stop="edit(data.item)"></i>
							</div>
						</template>


                        <template v-slot:row-details="row">
                            <product_preview :product="row.item" v-if="row.item.fast_preview"></product_preview>
                        </template>
					</b-table>

					<b-table v-else>

					</b-table>

					<div class="inb_pagi pt-4" v-if="rows.length > 0">
						<sys_pagination key="down"></sys_pagination>
					</div>

				</div>
			</div>
		</div>

		<product_modal></product_modal>
        <export_modal></export_modal>
	</div>
</template>

<script>
import {createHelpers} from 'vuex-map-fields';

const {mapFields} = createHelpers({
	getterType: 'inbox_state/getInboxStateField',
	mutationType: 'inbox_state/updateInboxStateField',
});

import {mapGetters} from "vuex";
import Filter_catalog from "./filter_catalog";
import grid from "../../../sys/grid/grid";
import Product_modal from "./product/product_modal";

import Sys_pagination from "../../../sys/pagination/pagination";
import Product_preview from "./preview/product_preview.vue";
import Export_modal from "./export/export_modal.vue";
export default {
	name: "catalog_view",
	components: {Export_modal, Product_preview, Sys_pagination, Product_modal, Filter_catalog,grid},

	data() {
		return {
			rows : [],

			percent_info : {
				"id" : 0,
				"percent": 0
			},
			is_load:true,
			is_check_all : false,
			is_filter_work : false,
			cur_records:35,
			active_items : [],
			fields : [

				{
					key : 'id',
					label: '',
					class:'text-center small_td'
				},
				{
					key : 'ordering',
					label: '<i class="fas fa-sort"></i>',
					class:'text-center hidden-md-down small_td'
				},
				{
					key : 'filename',
					label: '<i class="fas fa-photo-video"></i>',
					class:'text-center image_td'
				},
				{
					key : 'title',
					label: 'p.title',
					class:''
				},

				{
					key : 'price',
					label: 'p.price',
					class:'small_td__price'
				},
				{
					key : 'uniq_id',
					label: '<i class="fal fa-cog width-2"></i>',
					class:''
				},
			],
		}
	},

	props: {
		current_state: {
			type: Object
		},
	},

	created() {

		EventBus.$on("search_inbox_called",this.search_work);
		EventBus.$on("inbox_change_state",this.change_state);
		EventBus.$on("clean_inbox_filter",this.clean_inbox_filter);
		EventBus.$on("products_reload_items",this.load_items);
		EventBus.$on("filter_select_change",this.filter_select);
		EventBus.$on('product_publish',this.save_product_publish)
        EventBus.$on("reload_products",this.load_items);
	},

	mounted() {
		this.$store.dispatch('inbox_state/LOAD_STATES',this.current_state);
	},


	methods : {

        sync_menu() {
            EventBus.$emit('export_menu');
        },

        remove_skip_sync() {
            const is_ok = confirm_me(this.__t("REMOVE_SKIP_SYNC_ATTRIBUTES"));
            is_ok.then(res => {
                api.delete('/internal/v1/catalog/products/sync_flag').then(({data}) => {
                    if (data.status === "operation_success") {
                        EventBus.$emit("reload_products");
                    }

                }).catch(({response}) => {
                    EventBus.$emit('show_toast', {
                        err: response.data.message, type: "danger",
                        title: response.data.status,
                        position : "b-toaster-top-left"
                    })
                });
            });
        },

        async change_ordering(prod) {
            console.log('save_ordering',prod.id,prod.ordering);
            await api.patch('/internal/v1/catalog/products/'+ parseInt(prod.id) +'/ordering/' + parseInt(prod.ordering)).then(({data}) => {
                if (data.status === "operation_success") {
                    EventBus.$emit("reload_products");

                }
            })
            .catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });

        },

        async load_preview_details(row) {
            let product = row.item;
            if(row.item.hasOwnProperty("fast_preview")) {
                row.item.fast_preview = false;
            }
            else {
                row.item.fast_preview = true;
            }

            EventBus.$emit("product_edit",parseInt(product.id));
        },

		async save_product_publish(prod) {
			let prev = prod.published;

			await api.patch('/internal/v1/catalog/products/'+ parseInt(prod.id) +'/status').then(({data}) => {
					if (data.status === "operation_success") {
                        EventBus.$emit("reload_products");
					} else {
						prod.published = prev;
					}
				})
				.catch(({response}) => {
					prod.published = prev;
					EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
				});
		},

		edit (product) {
			EventBus.$emit("product_edit",parseInt(product.id));
		},

        open_item(product) {
            EventBus.$emit("product_edit",parseInt(product.id));
        },

        create() {
            EventBus.$emit("product_edit",0);
        },

        create_combo() {
            EventBus.$emit("combo_edit",0);
        },

		check_all() {

		},

		load_settings() {
			EventBus.$emit("edit_catalog_settings",this.percent_info);
		},

		rowClass(item) {
			if (!item) return;
			return item.class;
		},

		async load_items() {
			this.rows = [];
			this.is_load = true;

			await api.post('/internal/catalog/products')
				.then(({data}) => {
					this.is_load = false;
					if (data.status === "operation_success") {
						this.rows = data.data;
						//this.percent_info = data.message.glovo_percent;
						this.$store.dispatch('inbox_state/LOAD_PAGINATION', data.message.pagination);
					} else {
						this.rows = [];
					}
				}).then(res => {
					try {

					}
					catch (e) {

					}
				})
				.catch(({response}) => {
					this.is_load = false;
					this.rows = [];
					EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
				});
		},

		search_work(search_str) {
			if (myapp_config.debugState) {
				console.log("%c|___ LIST search", "color: #fd3995", search_str);
			}

			this.send_list.limit_start = 0;
			this.filter.search = search_str;

			this.change_state({
				type: "search_called"
			});
		},

		filter_select(res) {
			console.log("Filter_DATA",res);
			this.send_list.limit_start = 0;
			this.filter[res.type] = res.value;

			this.change_state({
				type: "filter_select"
			});
		},

		clean_inbox_filter() {

			this.send_list.limit_start = 0;
			this.filter.search = "";

			this.send_list.direction = "DESC";
			this.send_list.ordering = "ordering";

			let self = this;
			Object.keys(this.all_filter).map(name => {
				self.filter[name] = "";
			});

			this.change_state({
				type: "search_called",
				force_reload: true,
			});
		},

		async change_state(state_field) {
			this.is_load = false;
			if (myapp_config.debugState) {
				console.log("%c|___LIST change State...", "color: #fd3995", state_field);
			}

			let send = {
				filter: this.filter,
				list: this.send_list
			};
			this.__l(send,"info","State Send -> Reolad");

			await api.post("/internal/catalog/products/filter",qs.stringify(send)).then(({data}) => {
				if (data.status === "operation_success") {
					if (state_field.hasOwnProperty("force_reload")) {
						window.location.reload();
					} else {
						let res = data.message;
						if (res.hasOwnProperty("arr_state")) {
							this.$store.dispatch('inbox_state/LOAD_STATES', res.arr_state);
						}
					}
				}
			}).catch(({response}) => {
				EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
			});
		},

		nice_search(str) {
			if (!this.filter.hasOwnProperty('search')) {
				return str;
			}
			return str.replace(new RegExp(this.filter.search, "gi"), match => {
				return '<span class="text-danger">' + match + '</span>';
			});

		},
	},

	computed: {

		head_class() {

		},

		...mapGetters({
			'user' : "user/getUser",
		}),
		...mapFields([
			'list',
			'filter',
			'doc_type',
			'send_list',
			'all_filter'
		]),
	}
}
</script>

<style scoped>
	.prod_price {
		font-size: 20px;
	}
	.img_block img,
	.img_block picture {
		width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 5px;
	}
	.img_block {
		width: 75px;
		height: 75px;
	}
    .resolution_table thead th {
        border-bottom: 0 !important;
    }
</style>
